/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { CheckBox, Card, CardHeader, List, ListItemCustom, Bar } from '@ui5/webcomponents-react';
import { useEffect, useState } from 'react';

interface TaskLayoutProps {
    content: Data;
}

interface Data {
    id: string;
    type: string;
    title: string;
    subTitle?: string;
    taskData: TaskData;
    personalizationConfiguration?: any;
}

interface TaskData {
    title: string;
    taskBody: TaskBody;
}

interface TaskBody {
    id: string;
    taskList: TaskList[];
}

interface TaskList {
    id: string;
    task: string;
    approved: boolean;
}

const TaskLayout: React.FC<TaskLayoutProps> = ({ content }) => {
    const [updateList, setUpdateList] = useState<any>([]);
    useEffect(() => {
        setUpdateList(content.taskData.taskBody.taskList);
    }, [content.taskData.taskBody.taskList]);
    useEffect(() => {
        console.log(updateList);
    }, [updateList]);

    const changeTaskStatus = (id: string) => {
        const index = updateList.findIndex((elm: any) => elm.id === id);
        setUpdateList([
            ...updateList.slice(0, index),
            { ...updateList[index], approved: !updateList[index].approved },
            ...updateList.slice(index + 1),
        ]);
    };

    return (
        <Card
            header={<Bar startContent={<CardHeader titleText={content.taskData.title} />} />}
            style={{
                width: '800px',
            }}
        >
            <List>
                {updateList.map((listElement: any) => {
                    return (
                        <ListItemCustom key={listElement.id}>
                            <CheckBox checked={listElement.approved} text={listElement.task} onChange={() => changeTaskStatus(listElement.id)} />
                        </ListItemCustom>
                    );
                })}
            </List>
        </Card>
    );
};

export default TaskLayout;
